import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getAlaAgreementFile } from '../../api';
import { ALL_ALA_LEVELS_LABEL, MAX_ALA_LEVEL } from '../../utils/constants';
import { normalizeDateMonth } from '../../utils/date';

const propertyMap = (items = []) => {
  const itemNumber = 3;
  let output = items.slice(0, itemNumber)
    .join(', ');

  if (items.length > itemNumber) {
    output += ' +';
  }
  return output;
};

export const FILE_NAME = 'ala_level_agreements';
export const TITLE = 'ALA LEVEL AGREEMENTS';

export const TABLE_COLUMNS = [
  {
    Header: 'Origin',
    accessor: 'origin',
    Cell: ({ original: { origin } }) => propertyMap(origin),
    width: 80,
  },
  {
    Header: 'Dest',
    accessor: 'destination',
    Cell: ({ original: { destination = [] } }) => propertyMap(destination),
    width: 75,
  },
  {
    Header: 'Carrier',
    accessor: 'carrier.label',
    width: 80,
  },
  {
    Header: 'Postal Operator',
    accessor: 'postalOperator.label',
    width: 90,
  },
  {
    Header: 'ALA Levels',
    accessor: 'alaLevels',
    Cell: ({ original: { alaLevels = [] } }) => {
      if (alaLevels.length === MAX_ALA_LEVEL) {
        return ALL_ALA_LEVELS_LABEL;
      }
      return alaLevels.map(item => `ALA${item}`).join(', ');
    },
    width: 100,
  },
  {
    Header: 'Start Date',
    accessor: 'startDate',
    type: 'date',
    width: 100,
  },
  {
    Header: 'Stop Date',
    accessor: 'stopDate',
    type: 'date',
    width: 100,
  },
  {
    Header: 'Exceptions Start Date',
    accessor: 'exStartDate',
    type: 'date',
    width: 100,
  },
  {
    Header: 'Exceptions Stop Date',
    accessor: 'exStopDate',
    type: 'date',
    width: 100,
  },
  {
    Header: 'ALA Auto Approval Level',
    accessor: 'autoApprovalAlaLevel',
    Cell: ({ original: { autoApprovalAlaLevel } }) => (autoApprovalAlaLevel ? `ALA${autoApprovalAlaLevel}` : ''),
    width: 125,
  },
  {
    Header: 'Agreement Status',
    accessor: 'status',
    width: 155,
  },
  {
    Header: 'Agreement Status Update Date',
    accessor: 'statusUpdateDate',
    type: 'date',
    Cell: ({ original: { statusUpdateDate } }) => {
      if (statusUpdateDate) {
        return normalizeDateMonth(statusUpdateDate);
      }
      return '';
    },
    width: 100,
  },
  {
    Header: 'User Id Created By',
    accessor: 'creatorUsername',
    width: 100,
  },
  {
    Header: 'User Id Approved',
    accessor: 'approverUsername',
    width: 100,
  },
  {
    Header: 'Comment',
    accessor: 'comments',
    width: 100,
  },
  {
    Header: 'File',
    accessor: 'fileName',
    // eslint-disable-next-line react/prop-types
    Cell: ({ original: { id, fileName } }) => (fileName ? <FontAwesomeIcon icon="file-download" className="icon DownloadFile" onClick={() => getAlaAgreementFile(id)} /> : null),
    width: 100,
  },
  145,
];

export const COLUMNS = [
  {
    header: 'Origin',
    key: 'origin',
    width: 10,
  },
  {
    header: 'Destination',
    key: 'destination',
    width: 14,
  },
  {
    header: 'Carrier',
    key: 'carrier.label',
    width: 10,
  },
  {
    header: 'Postal Operator',
    key: 'postalOperator.label',
    width: 14,
  },
  {
    header: 'ALA Levels',
    key: 'alaLevels',
    width: 15,
  },
  {
    header: 'Start Date',
    key: 'startDate',
    width: 15,
  },
  {
    header: 'Stop Date',
    key: 'stopDate',
    width: 15,
  },
  {
    header: 'Exceptions Start Date',
    key: 'exStartDate',
    width: 19,
  },
  {
    header: 'Exceptions Stop Date',
    key: 'exStopDate',
    width: 19,
  },
  {
    header: 'ALA Auto Approval Level',
    key: 'autoApprovalAlaLevel',
    width: 19,
  },
  {
    header: 'Agreement Status',
    key: 'status',
    width: 22,
  },
  {
    header: 'Agreement Status Update Date',
    key: 'statusUpdateDate',
    width: 15,
  },
  {
    header: 'User Id Created By',
    key: 'creatorUsername',
    width: 14,
  },
  {
    header: 'User Id Approved',
    key: 'approverUsername',
    width: 14,
  },
  {
    header: 'Comment',
    key: 'comments',
    width: 18,
  },
  {
    header: 'File',
    key: 'file',
    width: 15,
  },
];
